import { render } from "./equipInstallations.vue?vue&type=template&id=145cbd52"
import script from "./equipInstallations.vue?vue&type=script&lang=js"
export * from "./equipInstallations.vue?vue&type=script&lang=js"

import "./equipInstallations.vue?vue&type=style&index=0&id=145cbd52&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__